// order matters for layout
export const accountParams = ['currencyCode', 'bankAccountNumber', 'sortCode', 'iban'] as const;
